import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import styles from './overlay.module.css';
import ModalCloseButton from '../ModalCloseButton';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import Alert from '@material-ui/lab/Alert';
import { ReactComponent as AddDevice } from '../../../utils/assets/add devices.svg';
import { withStyles } from '@material-ui/core/styles';
import { modalBackdropProps } from '../../../utils/styles/modal.overlay';

const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "var(--primary-text-theme-color)",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "var(--primary-text-theme-color)",
        },
        "& .MuiOutlinedInput-root": {
            color: "var(--primary-text-color)",
            backgroundColor: "var(--primary-popup-background-color)",
            minHeight: "48px",
            height: "auto",
            flexWrap: "wrap",
            alignItems: "center",
            padding: "6px 8px",
            overflowX: "visible",
            overflowY: "visible",
            borderRadius: "4px",
            border: "1px solid var(--primary-popup-stroke-color)",
            "& .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            "&:hover": {
                borderColor: "var(--primary-text-theme-color)",
            },
            "&.Mui-focused": {
                borderColor: "var(--primary-text-theme-color)",
                boxShadow: "none",
                outline: "none",
            },
            "& legend": {
                display: "none",
            },
        },
        "& .MuiChip-root": {
            outline: "none",
        },
        "& .MuiChip-root.Mui-focusVisible": {
            outline: "none",
            boxShadow: "none",
        },
        "& .MuiInputBase-input": {
            color: "var(--primary-text-color)",
            fontFamily: "Poppins",
            outline: "none",
        },
        "& .MuiAutocomplete-input": {
            minWidth: "120px",
            flex: "1 0 auto",
            outline: "none",
        },
        "& .MuiAutocomplete-tag": {
            margin: "2px",
        },
        "& .MuiInputBase-input::placeholder": {
            color: "var(--primary-text-color-80)",
            opacity: 1,
        },
        "& .MuiFormLabel-root": {
            color: "var(--primary-text-color-80)",
            fontFamily: "Poppins",
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "gray !important",
        },
        "& .MuiFormHelperText-root.Mui-error": {
            color: "red !important",
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "var(--primary-text-color)",
            color: "var(--primary-text-color)",
        },
        "& .MuiSvgIcon-root": {
            color: "var(--primary-text-color-80)",
        },
    },
})(TextField);

// import { useNavigate } from 'react-router-dom';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        backgroundColor: "var(--primary-popup-background-color)",
        color: "var(--primary-text-color)",
        border: "1px solid var(--primary-popup-stroke-color)",
    },
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? <ModalCloseButton onClick={onClose} /> : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function AddUser() {
  const axios = useAxiosPrivate()
  const [open, setOpen] = React.useState(false);
  const [emails, setEmails] = React.useState([]);
  const [emailsValidation, setEmailsValidation] = useState([]);
  // let navigate = useNavigate();

  const [alert, setAlert] = useState({
    showAlert: false,
    severity: 'success',
    message: '',
  });
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const addEmails = (arr) => {
    let testArray = [];
    setEmails(arr);
    arr.map((item) => {
      const result = checkEmail(item);
      if (result) {
        return testArray.push(true);
      } else {
        return testArray.push(false);
      }
    })
    setEmailsValidation(testArray);
  };

  const sendInvite = () => {
    if (emails.length === 0) {
      setAlert({
        showAlert: true,
        severity: 'error',
        message: 'Please enter an email address and press ENTER to invite.',
      });
      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: 'error',
          message: 'Please enter an email address and press ENTER to invite.',
        });
      }, 5000);
    }
    emails.filter((item) => checkEmail(item)).map(async (item) => {
      try {
        await axios.post('/team/invite', {
          email: item,
        });
        // navigate('/dashboard');
        window.location.href = '/dashboard';
        setAlert({
          showAlert: true,
          severity: 'Success',
          message: 'Sent invite Successfully!',
        });
        setTimeout(() => {
          setAlert({
            showAlert: false,
            severity: 'Success',
            message: 'Sent invite Successfully!',
          });
          handleClose();
        }, 5000);
      } catch (error) {
        if (error.response.status === 401) {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'Invalid Authentication!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'Invalid Authentication!',
            });
          }, 5000);
        } else if (error.response.status === 404) {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'User not found.!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'User not found.!',
            });
          }, 5000);
        } else if (error.response.status === 400) {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'Invalid email!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'Invalid email!',
            });
          }, 5000);
        } else {
          setAlert({
            showAlert: true,
            severity: 'error',
            message: 'Server error!',
          });
          setTimeout(() => {
            setAlert({
              showAlert: false,
              severity: 'error',
              message: 'Server error!',
            });
          }, 5000);
        }
      }
    });
  };
  const checkEmail = (address) => {
    let regex = new RegExp(
      // eslint-disable-next-line
      "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
    );
    const result = regex.test(address);

    return result
  };

  return (
    <div>
      <div
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={handleClickOpen}
      >
        {/* <img
            src={Device}
            width='30'
            height='30'
            alt='Device'
            style={{margin: '0 0 0 1rem'}}
        /> */}
        <AddDevice />
      </div>
      <BootstrapDialog
        maxWidth='lg'
        fullWidth
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
        BackdropProps={modalBackdropProps}
      >
        <BootstrapDialogTitle
          id='customized-dialog-title'
          onClose={handleClose}
        ></BootstrapDialogTitle>
        <DialogContent>
          <p className={styles.headerText}>Invite Players</p>
          <div className={styles.inputRow}>
            <Autocomplete
              multiple
              freeSolo
              fullWidth
              open={false}
              className={styles.autocomplete}
              onChange={(event, newValue) => {
                addEmails(newValue);
              }}

              options={[]}
              getOptionLabel={(option) => option}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <React.Fragment key={index}>
                    {checkEmail(option) ? (
                      <div className={styles.emailChip}>
                        <Chip
                          style={{
                            fontFamily: 'normal normal normal 12px Poppins',
                            letterSpacing: '0px',
                            background: '#ECF9F7',
                            color: '#000000',
                            opacity: 1,
                            // flexWrap: 'wrap',
                            fontWeight: 400,
                            fontSize: '1rem',
                            lineHeight: '1.37rem',
                            height: "2rem",
                            borderRadius: '6px',
                          }}
                          key={index}
                          size='small'
                          label={option}
                          deleteIcon={
                            <CloseIcon
                              style={{
                                fontSize: '0.65rem',
                                color: '#FFFFFF',
                                background: '#000000',
                                borderRadius: '50%',
                                padding: '1px',
                              }}
                            />
                          }
                          {...getTagProps({ index })}
                        />
                      </div>
                    ) : (
                      <div className={styles.errorChip}>
                        <Chip
                          style={{
                            fontFamily: 'normal normal normal 12px Poppins',
                            letterSpacing: '0px',
                            background: 'transparent',
                            color: '#FFFFFF',
                            opacity: 1,
                            flexWrap: 'wrap',
                            fontWeight: 400,
                            fontSize: '1rem',
                            lineHeight: '1.37rem',
                            height: "2rem",
                            borderRadius: '6px',
                          }}
                          key={index}
                          size='small'
                          label={option}
                          deleteIcon={
                            <CloseIcon
                              style={{
                                fontSize: '0.65rem',
                                color: '#000000',
                                background: '#FFFFFF',
                                borderRadius: '50%',
                                padding: '1px',
                              }}
                            />
                          }
                          {...getTagProps({ index })}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ))
              }
              renderInput={(params) => (
                <CssTextField
                  placeholder={
                    emails.length === 0
                      ? 'Insert email to add players, divide by enter'
                      : ''
                  }
                  InputLabelProps={{
                    style: { color: 'var(--primary-text-color-80)' },
                  }}
                  {...params}
                />
              )}
            />
            <button
              type='button'
              className={
                emailsValidation.includes(true) ? styles.searchButton : styles.disabled
              }
              disabled={!emailsValidation.includes(true)}
              onClick={emailsValidation.includes(true) ? sendInvite : undefined}
            >
              Send Invite
            </button>
          </div>
          {alert.showAlert && (
            <div style={{ padding: '0.5rem 2rem' }}>
              <Alert
                severity={alert.severity}
                onClose={() =>
                  setAlert({
                    ...alert,
                    showAlert: false,
                  })
                }
              >
                {alert.message}
              </Alert>
            </div>
          )}
          <p className={styles.descriptionText}>
            Visit Players to remove players and check their status.{' '}
          </p>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
